import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CategoryEntity } from '../../domain/entities/CategoryEntity'
import type { CategoryAdminDto } from '@/backend/market'
import moment from 'moment'
export class CategoryModel extends CategoryEntity {
  constructor(dataDto: CategoryAdminDto) {
    super()
    mapEntityProperties<CategoryModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
        branch: {
          name: dataDto.branchName,
          id: dataDto.branchId
        },
        imageUrl: dataDto.iconUrl,
        startTime: dataDto.startTime
          ? moment.utc(`2000-01-01 ${dataDto.startTime}`).local().format('HH:mm')
          : null,
        endTime: dataDto.endTime
          ? moment.utc(`2000-01-01 ${dataDto.endTime}`).local().format('HH:mm')
          : null
      }
    })
  }
}
